import React from 'react'
import { Send, Phone } from 'lucide-react'
import { Link } from 'react-router-dom'

export default function StickyMobileBar() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 border-t border-zinc-800 bg-black/95 px-4 py-3 md:hidden backdrop-blur-md">
      <div className="flex items-center gap-3">
        {/* Tlf nummer (ikke-klikbart link) */}
        <div
          className="flex flex-1 items-center justify-center gap-2 rounded-full border border-[#bb9b56]/50 bg-transparent py-2.5 text-sm font-semibold text-[#bb9b56]"
        >
          <Phone className="h-4 w-4 text-white" />
          50 99 82 82
        </div>

        {/* Få tilbud CTA */}
        <Link
          to="/kontakt"
          className="flex flex-1 items-center justify-center gap-2 rounded-full bg-[#bb9b56] py-2.5 text-sm font-semibold text-white shadow-lg shadow-[#bb9b56]/15 transition-all active:scale-95"
        >
          <Send className="h-4 w-4" />
          Få tilbud nu
        </Link>
      </div>
    </div>
  )
}
